var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { SDK_VERSION } from '../version';
import Axios from 'axios';
var HttpClient = /** @class */ (function () {
    function HttpClient(options, tokenProvider) {
        this.options = options;
        this.tokenProvider = tokenProvider;
        this.axios = Axios.create({
            withCredentials: true
        });
    }
    HttpClient.prototype.request = function (config) {
        return __awaiter(this, void 0, void 0, function () {
            var headers, token, data, code, message;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        headers = {
                            'x-authing-sdk-version': "js:" + SDK_VERSION,
                            'x-authing-userpool-id': this.options.userPoolId || '',
                            'x-authing-request-from': this.options.requestFrom || 'sdk',
                            'x-authing-app-id': this.options.appId || ''
                        };
                        if (!!(config && config.headers && config.headers.authorization)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.tokenProvider.getToken()];
                    case 1:
                        token = _a.sent();
                        token && (headers.Authorization = "Bearer " + token);
                        return [3 /*break*/, 3];
                    case 2:
                        headers.authorization = config.headers.authorization;
                        _a.label = 3;
                    case 3:
                        config.headers = headers;
                        config.timeout = this.options.timeout;
                        return [4 /*yield*/, this.axios.request(config)];
                    case 4:
                        data = (_a.sent()).data;
                        code = data.code, message = data.message;
                        if (code !== 200) {
                            this.options.onError(code, message, data.data);
                            throw new Error(JSON.stringify({ code: code, message: message, data: data.data }));
                        }
                        return [2 /*return*/, data.data];
                }
            });
        });
    };
    return HttpClient;
}());
export { HttpClient };
var NaiveHttpClient = /** @class */ (function (_super) {
    __extends(NaiveHttpClient, _super);
    function NaiveHttpClient(options, tokenProvider) {
        return _super.call(this, options, tokenProvider) || this;
    }
    NaiveHttpClient.prototype.request = function (config) {
        return __awaiter(this, void 0, void 0, function () {
            var headers, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        headers = {
                            'x-authing-sdk-version': "js:" + SDK_VERSION,
                            'x-authing-userpool-id': this.options.userPoolId || '',
                            'x-authing-request-from': this.options.requestFrom || 'sdk',
                            'x-authing-app-id': this.options.appId || ''
                        };
                        config.headers = __assign(__assign({}, headers), config.headers);
                        config.timeout = this.options.timeout;
                        return [4 /*yield*/, this.axios.request(config)];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    return NaiveHttpClient;
}(HttpClient));
export { NaiveHttpClient };
//# sourceMappingURL=data:application/json;base64,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